module.exports = __webpack_public_path__ + "static/media/IMG_6589.81e3a4de.jpg";